/**
 * Docebo Voucher model
 */
export class Voucher {
  constructor(
    public voucherCode: string,
    public isValid: boolean,
    public expirationDate: Date,
    public code: string,
    public codeName: string,
    public message: string
  ) {}
}
